import loadable from '@loadable/component'

export default {
    //众合法考为你指点迷津
    '/page/pcsem/activitySem3.html': loadable(() =>
        import('./SignUp/ActivitySem')
    ),
    '/page/pcsem/:pagename': loadable(() => import('./SignUp')),
    //众合法考只为听懂做对
    '/pc/sempc.html': loadable(() => import('./QualityCourse')),
    '/pc/sempcxin.html': loadable(() => import('./QualityCourse')),
    '/page/pcsem/wsempcxin/yanzheng.html': loadable(() =>
        import('./QualityCourse')
    ),
    '/page/pcsem/wsempcxin.html': loadable(() => import('./QualityCourse')),
    '/page/pcsem/360ppxin.html': loadable(() => import('./QualityCourse')),
    //法硕集训营
    '/page/pcsem/fashuo/px/yanzheng.html': loadable(() => import('./Camp')),
    '/page/pcsem/fashuo/px.html': loadable(() => import('./Camp')),
    // 扫除备考障碍
    '/page/pcsem/fashuo/pp/yanzheng.html': loadable(() =>
        import('./SweepObstacle')
    ),
    '/page/pcsem/fashuo/pp.html': loadable(() => import('./SweepObstacle')),
    //报考信息及信息查询
    '/page/pcsem/bmzc.html': loadable(() => import('./Query')),
    '/page/pcsem/bmzc/yanzheng.html': loadable(() => import('./Query')),
    // 报名条件信息查询平台
    '/page/pcsem/fashuo/bmzc.html': loadable(() => import('./QueryPlatform')),
    '/page/pcsem/fashuo/bmzc/yanzheng.html': loadable(() =>
        import('./QueryPlatform')
    ),
    //法考培训报名中心
    '/fakao/pcsem/px.html': loadable(() => import('./Train/Fakao')),
    '/fakao/pcsem/px.html?utm_source=sem_baidu': loadable(() =>
        import('./Train/Fakao')
    ),
    '/fakao/pcsem/px.html?utm_source=sem_360': loadable(() =>
        import('./Train/Fakao')
    ),
    '/page/pcsem/px.html': loadable(() => import('./Train/Page')),
    '/page/pcsem/360px.html': loadable(() => import('./Train/Px360')),
    '/page/pcsem/px/yanzheng.html': loadable(() => import('./Train/Verify'))
}
